import { useAtomValue } from 'jotai';
import {
  activeHomeTabAtom,
  type ActiveHomeTab,
} from '../states/homeTab.atom';

/**
 * 현재 활성 홈 탭 메타를 반환. 초기화 전/탭 없음 → null.
 * screen_name 외에 id/type/name까지 필요한 경우(로깅, 분기 등) 사용.
 */
export const useActiveHomeTab = (): ActiveHomeTab | null => {
  return useAtomValue(activeHomeTabAtom);
};
